import ProgramType from 'src/types/programType';

export interface ProgramMapping {
  productGroupLabel: string;
  categoryLabel: string;
  extraDimensionLabel: string;
  subcategoryLabel: string;
  hasExtraDimension: boolean;
  isExtraDimensionRequired: boolean;
}

export type ProgramLabelMapping = {
  [key in ProgramType]: ProgramMapping;
};

// Define program labels for dropdowns and table (can modify and extend)
export const programLabelMapping: ProgramLabelMapping = {
  [ProgramType.AmazonFresh]: {
    productGroupLabel: 'Product Group',
    categoryLabel: 'Category',
    extraDimensionLabel: 'Extra Dimension',
    subcategoryLabel: 'Subcategory',
    hasExtraDimension: false,
    isExtraDimensionRequired: false,
  },
  [ProgramType.Gfc]: {
    productGroupLabel: 'Temp Zone',
    categoryLabel: 'Drop Zone',
    extraDimensionLabel: 'Sub Drop Zone',
    subcategoryLabel: 'Velocity',
    hasExtraDimension: true,
    isExtraDimensionRequired: true,
  },
  [ProgramType.GfcEu]: {
    productGroupLabel: 'Temp Zone',
    categoryLabel: 'Drop Zone',
    extraDimensionLabel: 'Sub Drop Zone',
    subcategoryLabel: 'Velocity',
    hasExtraDimension: true,
    isExtraDimensionRequired: true,
  },
  [ProgramType.AmazonStyle]: {
    productGroupLabel: 'Product Group',
    categoryLabel: 'Category',
    extraDimensionLabel: 'Extra Dimension',
    subcategoryLabel: 'Subcategory',
    hasExtraDimension: true,
    isExtraDimensionRequired: false,
  },
  [ProgramType.Go]: {
    productGroupLabel: 'Product Group',
    categoryLabel: 'Category',
    extraDimensionLabel: 'Extra Dimension',
    subcategoryLabel: 'Subcategory',
    hasExtraDimension: false,
    isExtraDimensionRequired: false,
  },
  [ProgramType.WholeFoods]: {
    productGroupLabel: 'Product Group',
    categoryLabel: 'Category',
    extraDimensionLabel: 'Extra Dimension',
    subcategoryLabel: 'Subcategory',
    hasExtraDimension: false,
    isExtraDimensionRequired: false,
  },
};
